import { redirect } from '@tanstack/react-router';

import { loadRuntimeConfig } from '@/lib/runtime-config.js';

/**
 * Route guard of the Tasks page: sends a deep link home while the task tracker flag is off. The
 * config is read again on each navigation, so a tab left open honours a switch flipped later.
 */
export async function ensureTaskTrackerEnabled(): Promise<void> {
  const config = await loadRuntimeConfig(true);
  if (!config.features.taskTracker) {
    throw redirect({ to: '/' });
  }
}
